<template>
  <default-layout>
     <v-layout wrap>
         <v-flex xs12>
             <job-menu-bar></job-menu-bar>
         </v-flex>

         <v-flex xs12 class="pt-5">
             <job-table></job-table>
         </v-flex>
     </v-layout>
  </default-layout>
</template>
<script>
import JobMenuBar from './_components/job_menu.vue'
import JobTable from './_components/job_table.vue'

export default {
  name: 'JobIndexPage',
  components: {
    JobMenuBar,
    JobTable
  },
  data () {
    return {
      jobs: null
    }
  },
  methods: {
   
  },
  /*created () {
    this.$store.dispatch("get", "/job/all").then(res => {
      this.jobs = res.jobs;
    });
  }*/
}
</script>
